import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { jsx as _jsx } from "react/jsx-runtime";
import { lazy, Suspense } from 'react';
import { Skeleton } from 'seagull';
import { GetLazyPlayerTID, importReactPlayer, importYoutubePlayer } from './lazyPlayers.utils';
const ReactPlayerLazy = /*#__PURE__*/ lazy(importReactPlayer);
const YoutubePlayerLazy = /*#__PURE__*/ lazy(importYoutubePlayer);
const { LazyPlayerTID } = GetLazyPlayerTID('lazy-player');
const playerFallback = /*#__PURE__*/ _jsx(Skeleton, {
    width: "100%",
    height: "100%",
    testId: LazyPlayerTID.Skeleton()
});
const LazyReactPlayerComponent = (props)=>/*#__PURE__*/ _jsx(Suspense, {
        fallback: playerFallback,
        children: /*#__PURE__*/ _jsx(ReactPlayerLazy, _object_spread({}, props))
    });
const LazyYoutubePlayerComponent = (props)=>/*#__PURE__*/ _jsx(Suspense, {
        fallback: playerFallback,
        children: /*#__PURE__*/ _jsx(YoutubePlayerLazy, _object_spread({}, props))
    });
// WHY: lazy-wrapped players lose the static-method surface of the react-player types the
// IoContext contract requires; this single seam re-asserts that contract (same pattern as MockReactPlayer).
// eslint-disable-next-line no-restricted-syntax -- IoContext seam: lazy wrapper re-asserts react-player's static type surface
export const LazyReactPlayer = LazyReactPlayerComponent;
// eslint-disable-next-line no-restricted-syntax -- IoContext seam: lazy wrapper re-asserts react-player/youtube's static type surface
export const LazyYoutubePlayer = LazyYoutubePlayerComponent;
